/** Common variable **/
var window_width = $(window).width();


/** Product list page qty plus minus **/
	$('.qtyplus').click(function(e){
    // Stop acting like a button
    e.preventDefault();
    // Get its current value
    var currentVal = parseInt($(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $(this).parent('.addtocart .qty-box').find('input[name="quantity"]').val(0);
    }
  });

  $(".action-list.addtocart a.btn-cart.select-options").click(function(e) {
  	var currentVal = parseInt($(this).parent('.addtocart').find('.qty-box input[name="quantity"]').val());
  	if (!isNaN(currentVal) && currentVal > 0) {
      e.originalEvent.currentTarget.href = $(this).attr('href') + '?qty=' + currentVal + '&cache=false';
    }
  });


/** Toggle Minicart on Mobile **/
$(".icon-cart-header").click(function() {
  if (window_width <= 767) {
    $(".mini-cart .cart-wrapper").toggleClass("minicart-show");
  }
});
$("body").click(function(e) {
  if (window_width <= 767) {
    if (!$(e.target).closest(".mini-cart").length && $(".mini-cart .cart-wrapper").hasClass("minicart-show")) {
      $(".mini-cart .cart-wrapper").toggleClass("minicart-show");
    }
  }
});
$(".search-area a.search-icon").click(function() {
  if (window_width <= 767) {
    if ($(".mini-cart .cart-wrapper").hasClass("minicart-show")) {
      $(".mini-cart .cart-wrapper").toggleClass("minicart-show");
    }
  }
});

/** ALIGN HEIGHT FUNCTION: ALL ITEM HEIGHT SAME AS HIGHEST HEIGHT (INCLUDING PADDING) **/
function alignMinOuterHeight(selector) {
  $(selector).css('height', '');
  var minHeightName = 0;
  $(selector).each(function() {
    if (minHeightName < $(this).outerHeight()) {
      minHeightName = $(this).outerHeight()
    }
  });
  if (minHeightName > 0) {
    $(selector).css('height', minHeightName);
  }
}

$(document).ready(function() {

  /** Align height related product mobile **/

  if ($(".box_product_related").length && window_width <= 767) {
    alignMinOuterHeight('.box_product_related .category-products .owl-item .item-area');
    $(window).resize(function() {
      setTimeout(function() {
        alignMinOuterHeight('.box_product_related .category-products .owl-item .item-area');
      }, 1000)
    });
  }

  /** Align height related product grid **/
  var checkGridList = setInterval(function(){
    if($(".item.product-layout-grid").length){
      alignHeightProductGrid();
      clearInterval(checkGridList);
    } else if ($(".item.product-layout-list").length) {
      removeHeightProductList()
      clearInterval(checkGridList);
    }
  }, 500);

  $(".icon-mode-grid").click(function(){
    var checkGrid = setInterval(function(){
      if($(".item.product-layout-grid").length){
        alignHeightProductGrid();
        clearInterval(checkGrid);
      }
    }, 500);
  });

  $(".icon-mode-grid").click(function(){
    var checkList = setInterval(function(){
      if($(".item.product-layout-list").length){
        removeHeightProductList()
        clearInterval(checkList);
      }
    }, 500);
  });

  $(window).resize(function() {
    if($(".item.product-layout-grid").length){
      setTimeout(function() {
        alignHeightProductGrid();
      }, 1000)
    }
  });
  
  function alignHeightProductGrid() {
    setTimeout(function(){
      alignMinOuterHeight('.item.product-layout-grid .item-area .details-area .product-name');
    }, 500);

    setTimeout(function(){
      alignMinOuterHeight('.item.product-layout-grid .item-area .actions-area .price');
    }, 500);
  }

  function removeHeightProductList() {
    $('.item.product-layout-list .item-area .details-area .product-name').css('height', 'auto');
    $('.item.product-layout-grid .item-area .actions-area .price').css('height', 'auto');
  }

  // get params from url
  function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        var arr = [query_string[key], decodeURIComponent(value)];
        query_string[key] = arr;
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  }
  

  // Limited view on search
  $(document).on("change", ".limited-view-search .field", function(e) {
    e.preventDefault();
    var t = $(this), i = t.val();
    var urlParams = parse_query_string(window.location.search.substring(1));
    var searchUrl = '';
    if(urlParams.q != '') {
      searchUrl += window.location.pathname + '?q=' + urlParams.q;
      if(urlParams.type != '') {
        searchUrl += '&type=' + urlParams.type;
      }
      searchUrl += '&view=' + i;
    }
    if (searchUrl != '') {
      $.ajax({
        type: "POST",
        url: searchUrl,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function() {
          $("#resultLoading").show();
        },
        success: function(t) {
          $(".main-search-container .category-products").empty().html($(t).find(".main-search-container .category-products").html());
          $(".main-search-container .pagination").empty().html($(t).find(".main-search-container .pagination").html());
          $(".main-search-container .limited_wrap").empty().html($(t).find(".main-search-container .limited_wrap").html());
          if(history.pushState) {
            window.history.pushState({}, null, searchUrl);
          }
          setTimeout(function() {
            alignHeightProductGrid();
          }, 1000);
          setTimeout(function() {
            $("html,body").animate({
              scrollTop: $(".toolbar").offset().top
            }, 500)
          }, 100);
          $("#resultLoading").hide();       
        },
        error: function() {
          $("#resultLoading").hide();
        }
      });
    }
  });

  $(document).on("click", ".pagination-page-search a", function(e) {
    e.preventDefault();
    var newUrl = $(this).attr('href');
    $.ajax({
      type: "GET",
      url: newUrl,
      xhrFields: {
        withCredentials: true
      },
      beforeSend: function() {
        $("#resultLoading").show();
      },
      success: function(t) {
        $(".main-search-container .category-products").empty().html($(t).find(".main-search-container .category-products").html());
        $(".main-search-container .pagination").empty().html($(t).find(".main-search-container .pagination").html());
        $(".main-search-container .limited_wrap").empty().html($(t).find(".main-search-container .limited_wrap").html());
        if(history.pushState) {
          window.history.pushState({}, null, newUrl);
        }
        setTimeout(function() {
          alignHeightProductGrid();
        }, 1000);
        setTimeout(function() {
          $("html,body").animate({
            scrollTop: $(".toolbar").offset().top
          }, 500)
        }, 100);
        $("#resultLoading").hide();       
      },
      error: function() {
        $("#resultLoading").hide();
      }
    });
  });
});